module.exports = __webpack_public_path__ + "static/media/educationbg.bf81bbf8.png";